<template>
  <Block>
    <form>
      <InputValidate
        v-model="form.name"
        v-validate="'required'"
        :title="$t('full_name')"
        name="name"
        data-vv-value-path="innerValue"
        data-vv-validate-on="blur"
        :error="errors.first('name')"
      />

      <InputValidate
        v-model="form.idCard"
        v-validate="'required|numeric|length:16'"
        :title="$t('nik')"
        name="idCard"
        data-vv-value-path="innerValue"
        data-vv-validate-on="blur"
        :error="errors.first('idCard')"
        maxlength="16"
      />

      <InputDatePicker
        ref="birth"
        :date.sync="form.birthDate"
        :title="$t('birth')"
        name="birthDate"
      />

      <InputValidate
        v-model="form.birthCity"
        v-validate="'required'"
        :title="$t('place_of_birth_city')"
        name="birthCity"
        data-vv-value-path="innerValue"
        data-vv-validate-on="blur"
        :error="errors.first('birthCity')"
      />

      <InputValidate
        v-model="form.issuedCity"
        v-validate="'required'"
        :title="$t('2025090522509_eba207c5')"
        name="issuedCity"
        data-vv-value-path="innerValue"
        data-vv-validate-on="blur"
        :error="errors.first('issuedCity')"
        maxlength="50"
      />

      <!-- 国籍 -->
      <InputValidate
        v-model="countryCodeText"
        v-validate="'required'"
        :title="$t('nationality')"
        name="countryCode"
        data-vv-value-path="innerValue"
        :error="errors.first('countryCode')"
        :readonly="true"
        :show-arrow="true"
        @click.native="showCountryCodeSelector = true"
      />
      <md-selector
        v-model="showCountryCodeSelector"
        :default-value="form.countryCode"
        :data="countryCodeList"
        max-height="320px"
        :title="$t('nationality')"
        :ok-text="$t('done')"
        :cancel-text="$t('cancel')"
        large-radius
        @confirm="onSelectorConfirm"
      />

      <!-- 性别 -->
      <InputValidate
        v-model="genderText"
        v-validate="'required'"
        :title="$t('Gender')"
        name="gender"
        data-vv-value-path="innerValue"
        :error="errors.first('gender')"
        :readonly="true"
        :show-arrow="true"
        @click.native="showGenderSelector = true"
      />

      <md-selector
        v-model="showGenderSelector"
        :default-value="form.sex"
        :data="genderList"
        max-height="320px"
        :title="$t('Gender')"
        :ok-text="$t('done')"
        :cancel-text="$t('cancel')"
        large-radius
        @confirm="onSelectorGender"
      />

      <!-- 电子邮箱 -->
      <InputValidate
        v-model="form.email"
        v-validate="'required'"
        data-vv-value-path="innerValue"
        :error="errors.first('email')"
        name="email"
        :title="$t('email_address')"
      />
    </form>
  </Block>
</template>

<script>
import Block from '@/components/Block'
import InputValidate from '@/components/InputValidate'
import InputDatePicker from '@/components/InputDatePicker'

import {
  InputItem,
  Field,
  DatePicker,
  Button,
  ImageReader,
  Selector
} from 'mand-mobile'

export default {
  name: 'FromUp',
  components: {
    Block,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [DatePicker.name]: DatePicker,
    InputDatePicker,
    [Button.name]: Button,
    InputValidate,
    [ImageReader.name]: ImageReader,
    [Selector.name]: Selector
  },
  data () {
    const { k, idCardExpireDate, idCardIssueDate, ...ocrResult } = this.$route.query

    console.log(ocrResult)

    const validateCustom = {
      custom: {
        name: {
          required: () => this.$t('required')
        },
        idCard: {
          required: () => this.$t('required'),
          numeric: () => this.$t('numeric_error'),
          length: () => this.$t('numeric_error')
        },
        birthDate: {
          required: () => this.$t('required')
        },
        birthCity: {
          required: () => this.$t('required')
        },
        countryCode: {
          required: () => this.$t('required')
        },
        gender: {
          required: () => this.$t('required')
        },
        email: {
          required: () => this.$t('required')
        },
        issuedCity: {
          required: () => this.$t('required')
        }
      }
    }
    return {
      validateCustom,
      form: {
        ...ocrResult,
        email: ''
      },
      showCountryCodeSelector: false,
      showGenderSelector: false,
      countryCodeText: '',
      genderText: '',
      countryCodeList: [{ value: 'AFG', text: 'Afghanistan' }, { value: 'ALA', text: 'Aland Islands' }, { value: 'ALB', text: 'Albania' }, { value: 'DZA', text: 'Algeria' }, { value: 'ASM', text: 'American Samoa' }, { value: 'AND', text: 'Andorra' }, { value: 'AGO', text: 'Angola' }, { value: 'AIA', text: 'Anguilla' }, { value: 'ATA', text: 'Antarctica' }, { value: 'ATG', text: 'Antigua and Barbuda' }, { value: 'ARG', text: 'Argentina' }, { value: 'ARM', text: 'Armenia' }, { value: 'ABW', text: 'Aruba' }, { value: 'AUS', text: 'Australia' }, { value: 'AUT', text: 'Austria' }, { value: 'AZE', text: 'Azerbaijan' }, { value: 'BHS', text: 'Bahamas' }, { value: 'BHR', text: 'Bahrain' }, { value: 'BGD', text: 'Bangladesh' }, { value: 'BRB', text: 'Barbados' }, { value: 'BLR', text: 'Belarus' }, { value: 'BEL', text: 'Belgium' }, { value: 'BLZ', text: 'Belize' }, { value: 'BEN', text: 'Benin' }, { value: 'BMU', text: 'Bermuda' }, { value: 'BTN', text: 'Bhutan' }, { value: 'BOL', text: 'Bolivia' }, { value: 'BIH', text: 'Bosnia and Herzegovina' }, { value: 'BWA', text: 'Botswana' }, { value: 'BVT', text: 'Bouvet Island' }, { value: 'BRA', text: 'Brazil' }, { value: 'IOT', text: 'British Indian Ocean Territory ' }, { value: 'BRN', text: 'Brunei Darussalam' }, { value: 'BGR', text: 'Bulgaria' }, { value: 'BFA', text: 'Burkina Faso' }, { value: 'BDI', text: 'Burundi' }, { value: 'KHM', text: 'Cambodia' }, { value: 'CMR', text: 'Cameroon' }, { value: 'CAN', text: 'Canada' }, { value: 'CPV', text: 'Cape Verde' }, { value: 'CYM', text: 'Cayman Islands' }, { value: 'CAF', text: 'Central African Republic' }, { value: 'TCD', text: 'Chad' }, { value: 'CHL', text: 'Chile' }, { value: 'CHN', text: 'China' }, { value: 'CXR', text: 'Christmas Island' }, { value: 'CCK', text: 'Cocos (Keeling) Islands' }, { value: 'COL', text: 'Colombia' }, { value: 'COM', text: 'Comoros' }, { value: 'COG', text: 'Republic of the Congo' }, { value: 'COD', text: 'The Democratic Republic of the Congo' }, { value: 'COK', text: 'Cook Islands' }, { value: 'CRI', text: 'Costa Rica' }, { value: 'CIV', text: "Côte d'Ivoire" }, { value: 'HRV', text: 'Croatia' }, { value: 'CUB', text: 'Cuba' }, { value: 'CYP', text: 'Cyprus' }, { value: 'CZE', text: 'Czechia' }, { value: 'DNK', text: 'Denmark' }, { value: 'DJI', text: 'Djibouti' }, { value: 'DMA', text: 'Dominica' }, { value: 'DOM', text: 'Dominican Republic' }, { value: 'ECU', text: 'Ecuador' }, { value: 'EGY', text: 'Egypt' }, { value: 'SLV', text: 'El Salvador' }, { value: 'GNQ', text: 'Equatorial Guinea' }, { value: 'ERI', text: 'Eritrea' }, { value: 'EST', text: 'Estonia' }, { value: 'ETH', text: 'Ethiopia' }, { value: 'FLK', text: 'Falkland Islands (Malvinas)' }, { value: 'FRO', text: 'Faroe Islands' }, { value: 'FJI', text: 'Fiji' }, { value: 'FIN', text: 'Finland' }, { value: 'FRA', text: 'France' }, { value: 'GUF', text: 'French Guiana' }, { value: 'PYF', text: 'French Polynesia' }, { value: 'ATF', text: 'French Southern Territories' }, { value: 'GAB', text: 'Gabon' }, { value: 'GMB', text: 'Gambia' }, { value: 'GEO', text: 'Georgia' }, { value: 'DEU', text: 'Germany' }, { value: 'GHA', text: 'Ghana' }, { value: 'GIB', text: 'Gibraltar' }, { value: 'GRC', text: 'Greece' }, { value: 'GRL', text: 'Greenland' }, { value: 'GRD', text: 'Grenada' }, { value: 'GLP', text: 'Guadeloupe' }, { value: 'GUM', text: 'Guam' }, { value: 'GTM', text: 'Guatemala' }, { value: 'GGY', text: 'Guernsey' }, { value: 'GIN', text: 'Guinea' }, { value: 'GNB', text: 'Guinea-Bissau' }, { value: 'GUY', text: 'Guyana' }, { value: 'HTI', text: 'Haiti' }, { value: 'HMD', text: 'Heard Island and McDonald Islands' }, { value: 'VAT', text: 'Vatican' }, { value: 'HND', text: 'Honduras' }, { value: 'HKG', text: 'Hong Kong (China)' }, { value: 'HUN', text: 'Hungary' }, { value: 'ISL', text: 'Iceland' }, { value: 'IND', text: 'India' }, { value: 'IDN', text: 'Indonesia' }, { value: 'IRN', text: 'Iran' }, { value: 'IRQ', text: 'Iraq' }, { value: 'IRL', text: 'Ireland' }, { value: 'IMN', text: 'Isle of Man' }, { value: 'ISR', text: 'Israel' }, { value: 'ITA', text: 'Italy' }, { value: 'JAM', text: 'Jamaica' }, { value: 'JPN', text: 'Japan' }, { value: 'JEY', text: 'Jersey' }, { value: 'JOR', text: 'Jordan' }, { value: 'KAZ', text: 'Kazakhstan' }, { value: 'KEN', text: 'Kenya' }, { value: 'KIR', text: 'Kiribati' }, { value: 'PRK', text: 'North Korea ' }, { value: 'KOR', text: 'South Korea' }, { value: 'KWT', text: 'Kuwait' }, { value: 'KGZ', text: 'Kyrgyzstan' }, { value: 'LAO', text: 'Laos' }, { value: 'LVA', text: 'Latvia' }, { value: 'LBN', text: 'Lebanon' }, { value: 'LSO', text: 'Lesotho' }, { value: 'LBR', text: 'Liberia' }, { value: 'LBY', text: 'Libya' }, { value: 'LIE', text: 'Liechtenstein' }, { value: 'LTU', text: 'Lithuania' }, { value: 'LUX', text: 'Luxembourg' }, { value: 'MAC', text: 'Macao' }, { value: 'MKD', text: 'Macedonia' }, { value: 'MDG', text: 'Madagascar' }, { value: 'MWI', text: 'Malawi' }, { value: 'MYS', text: 'Malaysia' }, { value: 'MDV', text: 'Maldives' }, { value: 'MLI', text: 'Mali' }, { value: 'MLT', text: 'Malta' }, { value: 'MHL', text: 'Marshall Islands' }, { value: 'MTQ', text: 'Martinique' }, { value: 'MRT', text: 'Mauritania' }, { value: 'MUS', text: 'Mauritius' }, { value: 'MYT', text: 'Mayotte' }, { value: 'MEX', text: 'Mexico' }, { value: 'FSM', text: 'Micronesia' }, { value: 'MDA', text: 'Moldova' }, { value: 'MCO', text: 'Monaco' }, { value: 'MNG', text: 'Mongolia' }, { value: 'MNE', text: 'Montenegro' }, { value: 'MSR', text: 'Montserrat' }, { value: 'MAR', text: 'Morocco' }, { value: 'MOZ', text: 'Mozambique' }, { value: 'MMR', text: 'Myanmar' }, { value: 'NAM', text: 'Namibia' }, { value: 'NRU', text: 'Nauru' }, { value: 'NPL', text: 'Nepal' }, { value: 'NLD', text: 'Netherlands' }, { value: 'ANT', text: 'Netherlands Antilles' }, { value: 'NCL', text: 'New Caledonia' }, { value: 'NZL', text: 'New Zealand' }, { value: 'NIC', text: 'Nicaragua' }, { value: 'NER', text: 'Niger' }, { value: 'NGA', text: 'Nigeria' }, { value: 'NIU', text: 'Niue' }, { value: 'NFK', text: 'Norfolk Island' }, { value: 'MNP', text: 'Northern Mariana Islands ' }, { value: 'NOR', text: 'Norway' }, { value: 'OMN', text: 'Oman' }, { value: 'PAK', text: 'Pakistan' }, { value: 'PLW', text: 'Palau' }, { value: 'PSE', text: 'Palestine' }, { value: 'PAN', text: 'Panama' }, { value: 'PNG', text: 'Papua New Guinea' }, { value: 'PRY', text: 'Paraguay' }, { value: 'PER', text: 'Peru' }, { value: 'PHL', text: 'Philippines' }, { value: 'PCN', text: 'Pitcairn' }, { value: 'POL', text: 'Poland' }, { value: 'PRT', text: 'Portugal' }, { value: 'PRI', text: 'Puerto Rico' }, { value: 'QAT', text: 'Qatar' }, { value: 'REU', text: 'Réunion' }, { value: 'ROU', text: 'Romania' }, { value: 'RUS', text: 'Russian Federation' }, { value: 'RWA', text: 'Rwanda' }, { value: 'SHN', text: 'Saint Helena' }, { value: 'KNA', text: 'Saint Kitts and Nevis' }, { value: 'LCA', text: 'Saint Lucia' }, { value: 'SPM', text: 'Saint Pierre and Miquelon' }, { value: 'VCT', text: 'Saint Vincent and the Grenadines' }, { value: 'WSM', text: 'Samoa' }, { value: 'SMR', text: 'San Marino' }, { value: 'STP', text: 'Sao Tome and Principe' }, { value: 'SAU', text: 'Saudi Arabia' }, { value: 'SEN', text: 'Senegal' }, { value: 'SRB', text: 'Serbia' }, { value: 'SYC', text: 'Seychelles' }, { value: 'SLE', text: 'Sierra Leone' }, { value: 'SGP', text: 'Singapore' }, { value: 'SVK', text: 'Slovakia' }, { value: 'SVN', text: 'Slovenia' }, { value: 'SLB', text: 'Solomon Islands' }, { value: 'SOM', text: 'Somalia' }, { value: 'ZAF', text: 'South Africa' }, { value: 'SGS', text: 'South Georgia and the South Sandwich Islands' }, { value: 'ESP', text: 'Spain' }, { value: 'LKA', text: 'Sri Lanka' }, { value: 'SDN', text: 'Sudan' }, { value: 'SUR', text: 'Suriname' }, { value: 'SJM', text: 'Svalbard and Jan Mayen' }, { value: 'SWZ', text: 'Swaziland' }, { value: 'SWE', text: 'Sweden' }, { value: 'CHE', text: 'Switzerland' }, { value: 'SYR', text: 'Syria' }, { value: 'TWN', text: 'Taiwan (Province of China)' }, { value: 'TJK', text: 'Tajikistan' }, { value: 'TZA', text: 'Tanzania' }, { value: 'THA', text: 'Thailand' }, { value: 'TLS', text: 'Timor-Leste' }, { value: 'TGO', text: 'Togo' }, { value: 'TKL', text: 'Tokelau' }, { value: 'TON', text: 'Tonga' }, { value: 'TTO', text: 'Trinidad and Tobago' }, { value: 'TUN', text: 'Tunisia' }, { value: 'TUR', text: 'Turkey' }, { value: 'TKM', text: 'Turkmenistan' }, { value: 'TCA', text: 'Turks and Caicos Islands' }, { value: 'TUV', text: 'Tuvalu' }, { value: 'UGA', text: 'Uganda' }, { value: 'UKR', text: 'Ukraine' }, { value: 'ARE', text: 'United Arab Emirates' }, { value: 'GBR', text: 'United Kingdom' }, { value: 'USA', text: 'United States' }, { value: 'UMI', text: 'United States Minor Outlying Islands' }, { value: 'URY', text: 'Uruguay' }, { value: 'UZB', text: 'Uzbekistan' }, { value: 'VUT', text: 'Vanuatu' }, { value: 'VEN', text: 'Venezuela' }, { value: 'VNM', text: 'Vietnam' }, { value: 'VGB', text: 'Virgin Islands (British)' }, { value: 'VIR', text: 'Virgin Islands (U.S.)' }, { value: 'WLF', text: 'Wallis and Futuna' }, { value: 'ESH', text: 'Western Sahara' }, { value: 'YEM', text: 'Yemen' }, { value: 'ZMB', text: 'Zambia' }, { value: 'ZWE', text: 'Zimbabwe' }],
      genderList: [
        {
          value: 1,
          text: 'Male'
        },
        {
          value: 2,
          text: 'Female'
        }
      ]
    }
  },
  mounted () {
    this.$validator.localize('zh_CN', this.validateCustom)
  },
  methods: {
    onSelectorConfirm ({ text, value }) {
      this.countryCodeText = text
      this.form.countryCode = value
    },
    // 选择性别时
    onSelectorGender ({ text, value }) {
      this.genderText = text
      this.form.sex = value
    },
    // 校验
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.birth.validate()
        this.$validator.validate().then((result) => {
          if (result) {
            resolve(this.form)
          } else {
            reject(new Error())
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.step-form-id {
  .id-title {
    color: #b2b2b2;
  }

  img {
    width: 190px;
    height: auto;
  }

  .change-id {
    position: relative;
    margin-top: 20px;
    color: #10aeff;
    margin-bottom: 66px;

    .icon {
      width: 40px;
      height: 40px;
      color: #10aeff;
      vertical-align: middle;
      position: relative;
      top: -3px;
    }
  }
}
</style>
